import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Exam Location Details',
    label: 'สถานที่สอบทั้งหมด',
    path: '/:examCenterCode/exam-location/locations',
    requiredPermission: [APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW],
  },
  {
    value: 'Exam Location Requests',
    label: 'รายการยื่นคำขออนุมัติสถานที่สอบ',
    path: '/:examCenterCode/exam-location/requests',
    requiredPermission: [APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW],
  },
  // TODO: enable when the feature is ready
  // {
  //   value: 'Exam Location Cancellation',
  //   label: 'ยกเลิกการใช้งาน',
  //   path: '/:examCenterCode/exam-location/cancellations',
  //   requiredPermission: [APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_CANCELATION.VIEW],
  // },
];

export default function ExamLocationManagementNavigationTabs() {
  const { permissions } = usePermission();

  const filteredItems = useMemo(
    () =>
      TAB_ITEMS.filter(
        ({ requiredPermission }) =>
          requiredPermission?.some((permission) => permissions.includes(permission)) ?? true,
      ),
    [permissions],
  );

  return <NavigationTabs items={filteredItems} />;
}
